import type { UnitPresets } from "@/libs/units/presets";

export const europeanOilField: UnitPresets = {
  "Generic.Power.Hydraulic": "hp",
  "Generic.Power.Real": "kW",
  "Generic.Power.Apparent": "kVA",
  "Generic.Current": "A",
  "Generic.Density": "kg/m³",
  "Generic.FlowRate.Liquid": "m³/d",
  "Generic.FlowRate.Gas": "e³m³/d",
  "Generic.Length.Large": "Meters",
  "Generic.Length.Small": "Centimeters",
  "Generic.Ratio.Liquid": "m3/m3",
  "Generic.Mass": "kg",
  "Generic.Pressure": "Bar",
  "Generic.Speed": "ft/s",
  "Generic.Temperature": "C°",
  "Generic.Viscosity": "Centipoise",
  "Generic.Voltage": "V",
  "Generic.Volume": "L",
  "Generic.VolumeRate.PI": "m³/d/Bar",
  "Generic.Concentration": "ppm"
};
